export interface IAgentStatCode {
  SubStat: string;
  Master: string;
  FormattedSubStat: string;
  SubStatConfidential: boolean | undefined;
}
export interface ISelectedStatCodeData extends IAgentStatCode {
  AgencyContactPhone: string | undefined;
  AgencyServicingTypeCode: string;
  OMConfidential: boolean | undefined;
  AgencyName: string;
  Role: string;
  Tier: string;
  TrendingTier: string;
  IsRewardsManager: boolean | undefined;
  Region: string;
  PrimaryContactName: string;
  PrimaryContactEmail: string;
}

export class SelectedStatCodeData implements ISelectedStatCodeData {
  SubStat: string;
  Master: string;
  FormattedSubStat: string;
  SubStatConfidential: boolean | undefined;
  AgencyContactPhone: string | undefined;
  AgencyServicingTypeCode: string;
  OMConfidential: boolean | undefined;
  AgencyName: string;
  Role: string;
  Tier: string;
  TrendingTier: string;
  IsRewardsManager: boolean | undefined;
  Region: string;
  PrimaryContactName: string;
  PrimaryContactEmail: string;
  constructor() {
    this.SubStat = '';
    this.Master = '';
    this.FormattedSubStat = '';
    this.SubStatConfidential = undefined;
    this.AgencyServicingTypeCode = '';
    this.OMConfidential = undefined;
    this.AgencyName = '';
    this.Role = '';
    this.Tier = '';
    this.TrendingTier = '';
    this.IsRewardsManager = undefined;
    this.Region = '';
    this.PrimaryContactName = '';
    this.PrimaryContactEmail = '';
  }
}
